import { Component, OnInit, ViewChild } from '@angular/core';
import { HuntPackageRecord } from '@cyborg-monorepo/hunter/common';
import { Observable } from 'rxjs';
import { HuntPackageComponent } from '../../../../../../shared/components/hunt-package/hunt-package.component';
import { HuntPackageService } from '../../../../../../shared/services/hunt-package.service';

@Component({ standalone: false, 
  selector: 'cyborg-hunt-packages',
  templateUrl: './recently-updated.component.html',
})
export class HuntPackageContentComponent implements OnInit {
  @ViewChild(HuntPackageComponent) public huntPackage: HuntPackageComponent;
  public recentHuntPackages$: Observable<Array<HuntPackageRecord>>;

  constructor(private huntPackageService: HuntPackageService) {}

  public ngOnInit(): void {
    this.recentHuntPackages$ = this.huntPackageService.getRecentHuntPackages(5);
  }
}
